import React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import Radio from '@mui/material/Radio';
import {
  RadioGroup as MUIRadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/material';

const StyledFormControl = styled(FormControl)`
  width: fit-content;

  .MuiRadio-root {
    padding: 7px;
  }

  .MuiFormLabel-root {
    color: #272727;
    font-family: 'Whitney Medium';
  }

  .MuiFormControlLabel-label {
    color: #555555;
    font-family: 'Whitney Book';
  }

  .MuiFormHelperText-root.Mui-error,
  .error-text {
    color: #bf1e2d;
    font-family: Whitney Medium;
    font-size: 13px;
    margin-left: 0;
  }

  ${(props) =>
    props.disabled
      ? `
    .MuiFormLabel-root {
      color: #888;
    }
  `
      : ''}
`;

export function RadioGroup({
  name,
  value,
  formLabel,
  radioList,
  disabled = false,
  disabledMessage = '',
  errorMessage = '',
  onChange = () => {},
}) {
  const tooltipId = disabled ? String(Number(new Date())) : null;

  return (
    <StyledFormControl
      data-for={tooltipId}
      data-tip={disabledMessage}
      disabled={disabled}
      variant="standard"
      component="fieldset"
    >
      {tooltipId && (
        <ReactTooltip
          id={tooltipId}
          place="top"
          effect="solid"
          multiline={true}
        />
      )}
      <FormLabel component="legend">{formLabel}</FormLabel>
      <MUIRadioGroup
        aria-label="position"
        value={value}
        name={name}
        defaultValue={value}
        onChange={onChange}
      >
        {radioList.map((radio) => (
          <FormControlLabel
            key={radio.label}
            value={radio.value}
            control={<Radio color={radio.color} />}
            label={radio.label}
            labelPlacement={radio.labelPlacement || 'end'}
          />
        ))}
      </MUIRadioGroup>
      {errorMessage && (
        <FormHelperText className="error-text">{errorMessage}</FormHelperText>
      )}
    </StyledFormControl>
  );
}
